import { useLayoutEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

export default function HamburgerDropdownItem({ item, onNavigate }) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!contentRef.current) return;

    if (open) setHeight(contentRef.current.scrollHeight);
    else setHeight(0);
  }, [open]);

  return (
    <div className="hm-dd">
      <button
        type="button"
        className={`hm-dd__trigger ${open ? "is-open" : ""}`}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className="hm-dd__title">{item.title}</span>

        <ChevronDown
          className={`hm-dd__icon ${open ? "is-open" : ""}`}
          size={18}
        />
      </button>

      <div
        className="hm-dd__menu"
        style={{ maxHeight: `${height}px` }}
      >
        <div ref={contentRef} className="hm-dd__content">
          {item.items?.map((sub) => (
            <a
              key={sub.href + sub.label}
              href={sub.href}
              className="hm-dd__item"
              onClick={onNavigate}
            >
              {sub.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}